import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement("svg", { className: "spinner", viewBox: "0 0 50 50", fill: "none", ...a }, /* @__PURE__ */ e.createElement("circle", { className: "path", cx: 25, cy: 25, r: 20, strokeWidth: 5 }));
export {
  t as default
};
